import React, { useEffect } from 'react';
import { useState } from 'react';

import './InstructionPanel.css';

const InstructionPanel = props => {

	const { betLocked, isLinkSelected, hasBet } = props;

	const [hasTextChanged, setHasTextChanged] = useState(false);

	const betPanelClassName = (betLocked?" locked":"") || (hasBet?" has-bet":""),
		instructionsWizard = (betLocked && 'Solve the Chain') || (hasBet && 'Wager Locked In') || 'Place a Wager';

	const handleAnimationEnd = () => {
		setHasTextChanged(false);
	}

	const instrClassName = hasTextChanged ? 'changed': 'initial';

	useEffect(()=>{

		if (hasTextChanged===false && hasBet) {
			setHasTextChanged(true);
		}

	}, [hasBet]);

	return (
		<div className={"crg-instruction-panel" + betPanelClassName} onAnimationEnd={handleAnimationEnd}>
			<p className={instrClassName}>
				{instructionsWizard}
			</p>
		</div>
		);
}

export default InstructionPanel;



// WEBPACK FOOTER //
// ./src/components/ChainReactionGame/InstructionPanel.jsx